<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__top">
            <BackLink/>
        </div>
        <Form :data="form"
          :error="$v.form.$error"
          :formId="id"
          :formErrorMessage="errorMessage"
          @submit="submitSection">   
            <span class="caption-xl">{{subtitle}}</span>
            <Fieldset :title="title" type="heading">
                <div :class="['form-group push__top', {'form-group--error' : $v.form.$error}]">
                    <div class="grid-row push__bottom">
                        <div class="grid-col grid-xsmall-12 grid-medium-6 grid-large-6">
                            <span><strong>{{questionLead}}</strong></span>
                        </div>                        
                        <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="(label, index) in questionLabels" :key="questionLabels + index"> 
                            <span class="hide--small"><strong>{{label}}</strong></span>
                        </div>
                    </div>
                    <div class="grid-row push__bottom" v-for="(q, index) in questions" :key="'q' + q.id">
                        <div class="bg__light-grey spacer push__bottom"/>
                          <div class="grid-col grid-xsmall-12 grid-medium-6 grid-large-6">
                              <span class="heading-s block soft__right push__right push__bottom--half"><strong>{{q.question}}</strong></span>
                          </div>
                          <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="a in q.answers" :key="'q' + q.id + 'a' + a.id">
                              <div class="inline-block">                                              
                                  <RadioButton 
                                    :screenLabel="q.question + ' is '" 
                                    :label="questionLabels[a.id]" 
                                    :hideLabel="true" 
                                    :name="'q' + q.id" 
                                    :id="'q' + q.id + '-a' + a.id" 
                                    :value="a.id" 
                                    :model="answers[index].answer" 
                                    @change="changeValue(index,a.id)"
                                  />
                              </div>
                        </div>
                    </div>
                </div>
            </Fieldset>

            
        </Form>        
      </article>
    </div>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "SectionOfQuestions",
  created() {
    this.loadQuestion();
  },
  mounted() {
    this.loadAnswer();
  },
  data() {
    return {
      id : "",
      title: "",
      content: "",
      destination: "",
      errorMessage: "Please ensure all questions are answered and valid.",
      answers: [], 
      questions: [],
      questionLength : 0,
      form : {
          questions: []
      }
    };
  },
  validations() {
      const validations = { 
        form : {
          questions: {}
        }
      };
      for (var a = 0; a < this.questionLength; a++) {
          validations.form.questions[a] = {
            answer : { required }
          }
      }
      return validations;
  },
  methods: {    
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.questions = currentQuestion.questions;
      this.questionLength = currentQuestion.questions.length;
      this.id = currentQuestion.id;
      this.title = currentQuestion.title;
      this.subtitle = currentQuestion.subtitle;
      this.buttonText = currentQuestion.buttonText;
      this.questionLead = currentQuestion.questionLead;
      this.questionLabels = currentQuestion.questionLabels;
      this.destination = currentQuestion.destination;
      this.formatQuestions();
    },
    loadAnswer() {
      let previousResponse = dataService.wasAnsweredBefore(this.id);
      if (previousResponse) {
        for (var a = 0; a < this.questionLength; a++) {
          var q = previousResponse.answer[a].id;
          let radioButton = document.getElementById('q' + q + '-a' + previousResponse.answer[a].answer);
          radioButton.checked = true;
          this.changeValue(a, previousResponse.answer[a].answer);
        }
      }
    },
    formatQuestions(){
      // Empty Questions Base
      for (var b = 0; b < this.questionLength; b++) {
          this.form.questions.push({
            id: this.questions[b].id,
            question: this.questions[b].question,
            answer: null
          });
      }
      // Answers List
      for (var i = 0; i < this.questionLength; i++) {
        this.answers.push({
            id: this.questions[i].id,
            question: this.questions[i].question,
            answer: null
        });
      }
      
    },
    startQuestionnaire() {        
      this.$router.push({ path: this.destination });
    },
    changeValue(index, newValue) {
        this.answers[index].answer = newValue;
        this.form.questions[index].answer = newValue;
    },
    logResponse() {
      let response = {
        id: this.id,
        questionType: "SectionOfQuestions",
        answer: this.answers
      };
      dataService.logResponse(response);
    },
    submitForm(form, valid) {
        valid.$touch();
        if (valid.$pending || valid.$error) {
            setTimeout(() => {
                document.querySelector(".error-summary__link").focus()
            }, 0);
            return;	
        }
        this.logResponse();
        this.$router.push({ name: this.destination.toLowerCase() });
    },
    submitSection() {
      this.submitForm(this.form, this.$v.form);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>